<template>

<com-item :size="1" :no-hover="true" theme="blue">

	<template v-slot:stats>
				
		<core-widget class="summary">

			<div class="summary-total">{{ title[level] }}<small>{{ subtitle[level] }}</small></div>

			<div class="summary-change">

				<div class="summary-change-title"><span>You & geekgroup</span></div>

				<div class="summary-change-items">

					<div class="summary-change-item">

						<div class="summary-change-item-value"><core-date :date="$store.getters['session/user/date/sync/first']" size="large" theme="white" /></div>
						<div class="summary-change-item-text">First Sync on</div>
						
					</div>

					<div class="summary-change-item">

						<div class="summary-change-item-value"><core-date :date="$store.getters['session/user/date/registered']" size="large" theme="white" /></div>
						<div class="summary-change-item-text">Registered on</div>
						
					</div>

					<div class="summary-change-item" v-if="isTipjar">

						<div class="summary-change-item-value"><core-date :date="$store.getters['session/user/date/upgraded']" size="large" theme="white" /></div>
						<div class="summary-change-item-text">Tipped on</div>
						
					</div>

					<div class="summary-change-item" v-if="isPatreon">

						<div class="summary-change-item-value"><core-date :date="$store.getters['session/user/date/upgraded']" size="large" theme="white" /></div>
						<div class="summary-change-item-text">Patreon since</div>
						
					</div>

				</div>

			</div>
		
		</core-widget>

	</template>

</com-item>

</template>

<script>

import comItem from './../../profile/insights/common/Item'

export default {

	components: {
		'com-item': comItem
	},

    data: function() {

        return {
            title: {
                0: 'Registered',
                1: 'Tipper',
                2: 'Supporter',
                3: 'Power User',
                4: 'Group Leader'
            },
            subtitle: {
                0: 'Non-patreon',
                1: 'Legacy Tipjar Perks',
                2: 'Patreon',
                3: 'Patreon',
                4: 'Patreon'
            }
        }

    },

    computed: {

        isTipjar: function() {

            return this.level === 1

        },

        isPatreon: function() {

            return this.level > 1

        },

        level: function() {

            return this.$store.getters['session/upgraded']

        }

    }

}

</script>

<style scoped>

.summary {
	padding: 0px!important;
	border: 0px!important;
	width: 100%;
	height: 252px;
	display: flex;
	flex-direction: column;
}

.is-mobile .summary {
	height: 100%;
}

.summary-total {
	display: flex;
    flex-direction: column;
	color: #fff;
	font-size: 48px;
    padding: 60px 0px 50px 0px;
	font-weight: 700;
	width: 100%;
	text-align: center;
}

.summary-total small {
	font-size: 16px;
	text-align: center;
	font-weight: 400;
    margin-top: 4px;
	display: block;
}

.summary-total >>> span.currency {
	font-size: 48px;
	margin-right: 0px;
}

.summary-change {
	flex-shrink: 0;
	width: 100%;
	padding: 0px 10px 10px 10px;
	margin-bottom: 10px;
}

.summary-change-items {
	display: flex;
	flex-direction: row;
	justify-content: center;
	width: 100%;
}

.summary-change-item {
	width: 33.3%;
	display: flex;
	flex-direction: column;
}

.summary-change-item-value {
	align-items: center;
	display: flex;
	color: #fff;
	height: 64px;
	font-weight: 500;
	font-size: 28px;
	justify-content: center;
}

.summary-change-item-value.is-up {
	color: #5acf69;
}

.summary-change-item-value.is-down {
	color: #9c150e;
}

.summary-change-item-value .fa {
	font-size: 14px;
	margin-right: 6px;
}

.summary-change-item-value >>> span.currency {
	font-size: 14px;
}

.summary-change-item-value > div {
	height: 64px;
	display: flex;
	align-items: center;
}

.summary-change-item-text {
	height: 16px;
	flex-shrink: 0;
	color: #fff;
	font-size: 12px;
	text-align: center;
	font-weight: 400;
}

.summary-change-title {
	font-size: 14px;
	line-height: 16px;
    padding-bottom: 20px;
	font-weight: 500;
	color: #fff;
	text-align: center;
}

.summary-change-title span {
	background-color: #4881bb;
	display: inline-block;
	padding: 0px 20px;
	position: relative;
	z-index: 2;
}

.summary-change-title:after {
	content: ' ';
	display: block;
	height: 1px;
	background-color: rgba(0, 0, 0, 0.2);
	position: absolute;
	right: 0px;
	top: 7px;
	left: 0px;
	z-index: 1;
}

</style>